<div class="modal-header align-items-center py-2" modalHeader data-testid="column-visibility-modal">
  <h2 class="mb-0">Show / hide columns</h2>
  <i class="bi bi-x-lg close-x ml-auto py-1 px-2" (click)="close()"></i>
</div>

<div class="modal-body" modalContent>
  <p class="cv-hint">Choose which columns to display.</p>
  <div class="cv-list">
    <div
      *ngFor="let col of columns"
      class="cv-row"
      [class.cv-row--locked]="isLastVisible(col)"
      [attr.data-col]="col.key"
      [attr.data-testid]="'cv-row-' + col.key"
      (click)="toggle(col)"
    >
      <div class="cv-row__name">
        {{ (col.label || col.header) | titlecase }}
        <!-- Clicks belong to the row (it owns the toggle), so the icon swallows its own. -->
        <span
          *ngIf="hint(col) as text"
          class="bi bi-info-circle-fill cv-row__hint"
          [ngbTooltip]="text"
          placement="top"
          container="body"
          (click)="$event.stopPropagation()"
        ></span>
      </div>
      <tablesready-switcher
        role="switch"
        [attr.aria-checked]="!col.hidden"
        [attr.aria-disabled]="isLastVisible(col)"
        [attr.data-testid]="'cv-toggle-' + col.key"
        [ngModel]="!col.hidden"
        [ngModelOptions]="{ standalone: true }"
        [disabled]="isLastVisible(col)"
      ></tablesready-switcher>
    </div>
  </div>
</div>

<div class="modal-footer" modalFooter>
  <button
    type="button"
    class="btn btn-info-outline"
    data-testid="cv-show-all"
    [disabled]="!anyHidden"
    (click)="showAll()"
  >
    Show all
  </button>
  <button type="button" class="btn btn-primary" data-testid="cv-done" (click)="close()">Done</button>
</div>
